import React, { useEffect, useState } from "react";
import { Box, DialogActions, DialogContent } from "@mui/material";
import {
  StarRatingoComponent,
  TextInputComponent,
} from "../../../atom";
import DropDownComponent from "../../../atom/Inputs/DropDown";
import TextButtonComponet from "../../../atom/Buttons/TextButton";
import { useDispatch } from "react-redux";
import { Actions } from "../../../../core/modules/Actions";
import { getText } from "../../../../core/Constant";
import TextAreaComponent from "../../../atom/Inputs/TextArea";

const AddRandomReviewForm = ({ onclickcancel, courseList, open }) => {
  const dispatch = useDispatch();

  const initialErrorsState = {
    courseId: "",
    rating: "",
    feedback: "",
    reviewerName: "",
  };

  const [courseId, setCourseId] = useState(0);
  const [isSelectedCourseValid, setSelectedCourseValid] = useState(false);
  const [isSelectedCourseError, setSelectedCourseError] = useState(false);

  const [rating, setRating] = useState(0);
  const [isRatedValid, setRatedValid] = useState(false);
  const [isRatedError, setRatedError] = useState(false);

  const [feedBack, setFeedBack] = useState("");
  const [isFeedBackValid, setFeedBackValid] = useState(false);
  const [isFeedBackError, setFeedBackError] = useState(false);

  const [reviewerName, setReviewerName] = useState("");
  const [isReviewerNameValid, setReviewerNameValid] = useState(false);
  const [isReviewerNameError, setReviewerNameError] = useState(false);

  const [errors, setErrors] = useState(initialErrorsState);

  useEffect(() => {
    if (open) {
      // Reset form when dialog opens
      setErrors(initialErrorsState);
      setSelectedCourseError(false);
      setSelectedCourseValid(false);
      setFeedBackError(false);
      setFeedBackValid(false);
      setRatedError(false);
      setRatedValid(false);
      setReviewerNameError(false);
      setReviewerNameValid(false);
      setCourseId("");
      setFeedBack("");
      setRating("");
      setReviewerName("");
    }
  }, [open]);

  const onCourseChange = (e) => {
    const id = getText(e);
    setCourseId(id);
    setSelectedCourseError(false);
    setSelectedCourseValid(id ? true : false);
  };

  const onFeedBackChange = (e) => {
    const value = getText(e);
    setFeedBack(value);
    setFeedBackValid(value?.length > 3);
    setFeedBackError(false);
  };

  const onRatingChange = (e) => {
    const value = getText(e);
    setRating(value);
    setRatedError(false);
    setRatedValid(value > 0);
  };

  const onReviewerNameChange = (e) => {
    const value = getText(e);
    setReviewerName(value);
    setReviewerNameValid(value?.trim()?.length > 0);
    setReviewerNameError(false);
  };

  const validateForm = () => {
    const newErrors = { ...initialErrorsState };

    if (!isFeedBackValid) {
      newErrors.feedback = "Feedback is required";
      setFeedBackError(true);
    }
    if (!isSelectedCourseValid) {
      newErrors.courseId = "Course selection is required";
      setSelectedCourseError(true);
    }

    if (!isRatedValid) {
      newErrors.rating = "Please rate the course before submit";
      setRatedError(true);
    }

    if (!isReviewerNameValid) {
      newErrors.reviewerName = "Reviewer name is required";
      setReviewerNameError(true);
    }

    setErrors(newErrors);

    // Return true if there are no errors
    return Object.values(newErrors).every((error) => !error);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validateForm()) {
      dispatch(
        Actions.review.addStudentReviewByAdmin({
          course_id: courseId,
          rating: rating,
          feedback: feedBack,
          reviewer_name: reviewerName,
          review_type: 1
        })
      );
      onCloseDialog();
    }
  };

  const emptyForm = () => {
    setErrors(initialErrorsState);
    setSelectedCourseError(false);
    setSelectedCourseValid(false);
    setFeedBackError(false);
    setFeedBackValid(false);
    setRatedError(false);
    setRatedValid(false);
    setReviewerNameError(false);
    setReviewerNameValid(false);
    setCourseId("");
    setFeedBack("");
    setRating("");
    setReviewerName("");
  };

  const onCloseDialog = () => {
    emptyForm();
    onclickcancel();
  };

  return (
    <Box p={1}>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <Box>
            <Box mt={2} mb={2}>
              <Box style={{ padding: 10 }}>
                  <TextInputComponent
                  name="reviewerName"
                  label="Reviewer Name"
                  value={reviewerName}
                  onchange={onReviewerNameChange}
                  placeholder="Enter reviewer name"
                  readOnly={false}
                  isError={errors.reviewerName !== "" ? true : false}
                  error={errors?.reviewerName}
                />
              </Box>
            </Box>

            <Box mt={2} mb={2}>
              <Box style={{ padding: 10 }}>
                <p
                  style={{
                    padding: 0,
                    margin: 0,
                    color: "#4E657C",
                    fontSize: 19,
                    fontWeight: 500,
                  }}
                >
                  Rating
                </p>

                <StarRatingoComponent
                  name="simple-controlled"
                  onChange={onRatingChange}
                  value={rating}
                  precision={1}
                  isError={errors.rating !== "" ? true : false}
                  error={errors?.rating}
                />
              </Box>
            </Box>
            <Box mt={2} mb={2}>
              <DropDownComponent
                isError={isSelectedCourseError}
                error={"Please select a course"}
                placeholder="Select Course"
                onchange={onCourseChange}
                list={courseList}
                selectedValue={courseId}
                isShowZero={false}
                dropdownLabel="Course"
                fixedWidth="100%"
              />
            </Box>

            <Box mt={2} mb={2}>
              <TextAreaComponent
                textlabel={"Feedback"}
                name="feedback"
                value={feedBack}
                onchange={onFeedBackChange}
                placeholder="feedback"
                readOnly={false}
                isError={errors.feedback !== "" ? true : false}
                error={errors?.feedback}
              />
            </Box>
          </Box>
        </DialogContent>

        <DialogActions>
          <Box sx={{ display: "flex", width: "50%", mr: 2.2, mb: 2, ml: 2.2 }}>
            <Box sx={{ display: "flex", gap: 0.5, flexGrow: 1 }}>
              <Box sx={{ flexGrow: 1 }}>
                <TextButtonComponet
                  text="Add"
                  classStyle="btn btn-primary"
                  onButtonClick={handleSubmit}
                />
              </Box>
              <Box sx={{ flexGrow: 1 }}>
                <TextButtonComponet
                  text="Cancel"
                  classStyle="btn btn-secondary"
                  onButtonClick={onCloseDialog}
                />
              </Box>
            </Box>
          </Box>
        </DialogActions>
      </form>
    </Box>
  );
};

export default AddRandomReviewForm;
